import { kohLarnGetYourGuideAttractions } from '../../../config/affiliates/attractions/get-your-guide/koh-larn';
import { Content } from '../../types';

export const kohLarnContent: Content = {
  title: 'קו לארן - פנינה הטרופית שליד פטאיה',
  imageUrl: '/images/thailand/koh-larn/koh-larn-wide.jpeg',
  introduction:
    'קו לארן (Koh Larn) הוא אי קטן אך מרהיב ביופיו, השוכן במפרץ תאילנד, במרחק קצר מהעיר פטאיה. האי, מציע נופים טרופיים עוצרי נשימה, חופים עם חול לבן ומים צלולים בגוון טורקיז ואווירה רגועה ושלווה המזכירה איים יווניים. קו לארן מהווה יעד פופולרי, הן עבור תיירים השוהים בפטאיה והן עבור מקומיים המחפשים מפלט שקט מהמולת העיר.',
  sections: [
    {
      title: 'מזג אוויר בקו לארן',
      type: 'sub-headers',
      description:
        'קו לארן נהנה מאקלים טרופי חם ולח לאורך כל השנה, דבר ההופך אותו ליעד מתאים לביקור כמעט בכל עונה. עם זאת, כמו בכל יעד טרופי, יש עונות המתאימות יותר לנופש וחופשה - תלוי בהעדפותיכם האישיות בהתייחס לחום, גשמים והמולה תיירותית. להלן פירוט לפי עונות:',
      content: [
        {
          subtitle: 'נובמבר - מרץ - העונה היבשה והנעימה',
          text: 'זוהי התקופה הכי פופולרית והמומלצת לביקור באי. מזג האוויר יבש, עם טמפרטורות נוחות יחסית שנעות סביב 24 עד 30 מעלות ביום וערבים נעימים עם בריזה קלה. השמיים לרוב כחולים והים רגוע, מושלם לשחייה, שנורקלינג ושייט. זוהי גם עונת השיא מבחינת התיירות - החופים מלאים אך לא עמוסים מדי ושירותי התיירות בשיאם.',
        },
        {
          subtitle: 'אפריל - יוני - תחילת עונת הקיץ וחגיגות מקומיות',
          text: 'הטמפרטורות עולות, והחום כבר מורגש - מעל 32 מעלות בממוצע. זוהי תקופה נהדרת לאלו שלא נרתעים מהחום ומעוניינים להרוויח תקופה לא צפופה. באפריל נחגג חג הסונגקראן (ראש השנה התאילנדי) - חוויה צבעונית ורטובה גם באיים. לקראת סוף מאי כבר יורדים גשמים קלים, אך אין מדובר בעונה גשומה של ממש.',
        },
        {
          subtitle: 'יולי - אוקטובר - עונת הגשמים והשלווה',
          text: 'עונה זו נחשבת ל"עונת השפל" מבחינה תיירותית, אך מתאימה מאוד למחפשים שקט אמיתי, מחירים נוחים ונוף ירוק במיוחד. הגשמים יורדים בתדירות גבוהה יותר, אך לרוב מדובר בגשמים קצרים, בעיקר בשעות אחה"צ או בלילה. בימים נטולי גשם - החופים שוממים, האווירה קסומה והטבע בשיאו. יחד עם זאת, יש לקחת בחשבון כי הים יכול להיות סוער וחלק מהפעילויות הימיות עשויות להתבטל.',
        },
      ],
    },
    {
      title: 'אזורים מומלצים ללינה בקו לארן',
      type: 'sub-headers',
      description:
        'למרות שקו לארן נתפס לעיתים כיעד לטיול יום קצר מפטאיה, רבים מגלים שהקסם האמיתי של האי נחשף בשעות הערב ו/או הבוקר המוקדמות - כאשר רוב התיירים עוזבים והאי מתכסה בשקט, רוגע וניחוחות מלוחים מהים. הלינה באי, מאפשרת לחוות אותו בקצב איטי יותר, להנות משקיעות רומנטיות ומאווירה כפרית מרגיעה.',
      content: [
        {
          subtitle: 'Na Baan Village - הכפר המרכזי והנוח',
          text: 'זהו לבו הפועם של האי, אזור הנמל המרכזי אליו מגיעות המעבורות מפטאיה. בכפר תמצאו בתי קפה קטנים, מסעדות מקומיות, מאפיות, בתי מרקחת ודוכנים להשכרת אופנועים. זה המקום הנוח ביותר ללינה למעדיפים גישה נוחה לתחבורה ציבורית, שירותי תיירות, קרבה למסעדות ולאקשן. הלינה כאן נעה בין גסטהאוסים פשוטים לבתי מלון קטנים בסגנון מקומי. האזור אינו שקט לחלוטין, אך מספק איזון טוב בין נוחות לרגיעה.',
        },
        {
          subtitle: 'Tawaen Beach - לתיירים האוהבים להיות במרכז העניינים',
          text: 'אזור החוף המתוייר באי - Tawaen - מושך אליו את מרבית התיירים, בעיקר בזכות החוף הרחב, המסעדות, הדוכנים, הפעילויות והנגישות הגבוהה. מבחר רחב של מקומות לינה - החל ממלונות בסיסיים ועד ריזורטים נעימים עם נוף לים. החיסרון - עומס, במיוחד בשעות היום, היתרון - הכול נמצא במרחק הליכה.',
        },
        {
          subtitle: 'Ta Yai & Tien Beach - למחפשים שקט ורומנטיקה',
          text: 'שני אזורים אלו אידיאלים עבור מטיילים המחפשים להתנתק מהעולם. חופים אלו, Ta Yai (החוף הקטן באי) ו - Tien (מהחופים היפים ביותר בתאילנד כולה) פונים בעיקר לזוגות, צלמים ומטיילים המעדיפים טבע ושקט על פני נוחות מלאה. מקומות הלינה כאן מעוצבים לעתים קרובות כמלונות בוטיק, עם קווים כפריים ותחושת פרטיות גבוהה. יש לקחת בחשבון כי הגישה אל/ ממרכז האי אורכת מספר דקות נסיעה באופנוע, אך התמורה שווה כל רגע.',
        },
        {
          subtitle: 'אפשרויות לינה מומלצות במיוחד',
          text: '<strong>Xanadu Beach Resort - </strong>ריזורט ברמה גבוהה ממש על קו החוף, עם נוף פתוח לים, מסעדה מעולה וחוף כמעט פרטי. מתאים מאוד לזוגות או משפחות קטנות המחפשות נוחות ויוקרה. <br/><strong>Lareena Resort -</strong> מלון אינטימי ומטופח סמוך לרציף המעבורות. לחלק מהחדרים קיימות מרפסות מעל המים, חוויה מרגיעה במיוחד. <br/><strong>Koh Larn Villa Resort -</strong> אופציה טובה למעוניינים בלינה נוחה בתקציב בינוני, לא רחוק מהמרכז אך מספיק שקט. מתאים גם לקבוצות קטנות. <br/><strong>טיפ חשוב - </strong>בשל גודלו הקטן של האי והביקוש הגבוה בחודשים נובמבר - מרץ, מומלץ מאוד להזמין מקומות לינה עבור תקופה זו מראש, דגש על סופי שבוע וחגים תאילנדיים.',
        },
      ],
    },
    {
      title: 'תחבורה ציבורית והשכרת אופנועים בקו לארן',
      type: 'sub-headers',
      description:
        'התחבורה הפנימית בקו לארן פשוטה ונוחה וזוהי אחת הסיבות לכך שהאי כל כך אהוב על מטיילים. גודלו הקטן של האי - רק כ - 4 ק"מ לאורך, מאפשר לנוע בין האתרים המרכזיים תוך דקות ספורות, ללא צורך בתחבורה מורכבת או יקרה.',
      content: [
        {
          subtitle: 'השכרת אופנועים - הבחירה הפופולרית ביותר',
          text: 'רוב המטיילים מעדיפים לשכור אופנוע מיד עם הגעתם לרציף Na Baan. מדובר בדרך הנוחה, הגמישה והזולה ביותר להתניידות עצמאית באי. עלות השכירות ליום הינה כ200-300 באט (לרוב, כולל קסדה) והליך ההשכרה הינו קליל ופשוט, ברציף עצמו. נזכיר שוב, כי אף אם המשכיר אינו דורש זאת, הרי שנדרש רשיון נהיגה רלוונטי בתוקף וכן רשיון בינלאומי תואם וכמובן, לנהוג בזהירות - הכבישים באי צרים ולעיתים אף תלולים ודלק נמכר בבקבוקים בתחנות קטנות לאורך הדרכים. <br/>מתאים עבור זוגות, מטיילים בודדים או קבוצות קטנות המחפשות חופש, גישה מהירה לחופים מרוחקים ורצון לחקור את האי ולעצור לתמונות מהממות מתי שרק בא להם.',
        },
        {
          subtitle: 'מוניות סונגטאו (Songthaew) - תחבורה ציבורית מקומית',
          text: 'הסונגטאו הינו טנדר פתוח עם ספסלים מאחור - מעין מונית שירות תאילנדית. זוהי דרך זולה ופשוטה להתנייד באי למי שאינו מעוניין לשכור אופנוע. העלות הינה כ - 30 עד 50 באט לנוסע (בהתאם למרחק ולעיתים אף בהתאם למזג האוויר ולביקוש). זמינות גבוהה בעיקר סביב הנמל ובחופים מרכזיים ואין לוח זמנים רשמי - הרכב יוצא כשהוא מתמלא או לפי הצורך. ניתן אף לשכור סונגטאו פרטי לנסיעה ייעודית - למשל, לקבוצות קטנות. <br/>מתאים עבור משפחות עם ילדים, למטיילים המעדיפים שלא לנהוג או לאלו המגיעים לטיול קצר של כמה שעות בלבד.',
        },
        {
          subtitle: 'אופניים חשמליים - אלטרנטיבה שקטה וירוקה',
          text: 'ניתן למצוא השכרת אופניים חשמליים, בעיקר באזור Na Baan. זו אופציה שקטה, סביבתית ונעימה במיוחד לטיול רגוע. העלות הינה כ - 150 עד 250 באט ליום ומתאימה עבור נסיעות קצרות בלבד - לא תמיד מתמודדת טוב עם עליות. הזמינות מוגבלת יחסית, אך אפשרית. <br/>מתאים עבור מטיילים רגועים המעדיפים סיורים איטיים, ללא רעש מנועים ועם קצב אחר. מושלם ליום שקט עם עצירות בחופים, בתי קפה ותצפיות.',
        },
        {
          subtitle: 'טיפים חשובים',
          text: '✓ חשוב לבדוק את מצב האופנוע/ האופניים מבחינה מכנית, טרם השכירות (בלמים, פנסים, מראה).<br/> ✓ השכרות רבות יבקשו פיקדון של דרכון או סכום כסף קטן - לעולם אל תשאירו דרכון! צילום דרכון אפשרי בהחלט או סכום כספי.<br/> ✓ קחו אתכם כובע, מים וקרם הגנה - השמש חזקה לאורך הדרכים.<br/> ✓ יש חניה מסודרת ליד רוב החופים. שימו לב לשילוט אם יש גישה לכלי רכב.<br/>',
        },
      ],
    },
    {
      title: 'דרכי הגעה לקו לארן',
      type: 'sub-headers',
      description:
        'ההגעה לקו לארן הינה פשוטה, נוחה ומתאימה לכל סוגי המטיילים - החל ממטיילים עצמאיים ועד משפחות עם ילדים. מיקומו של האי, במרחק קצר של כ - 7 ק"מ בלבד מהחוף של פטאיה, מאפשר לשלב אותו בקלות כחלק מטיול גדול יותר באזור, או כטיול יום ממקום לינה בעיר.',
      content: [
        {
          subtitle: 'הגעה לפטאיה',
          text: 'רוב המטיילים מגיעים תחילה לעיר פטאיה, הממוקמת כ - 150 ק"מ דרום מזרחית לבנגקוק. ניתן להגיע אליה בדרכים הבאות:<br/> <strong>רכב/ מונית פרטית מבנגקוק -</strong> דרך נוחה מאוד, עבור משפחות או קבוצות. אורכת כשעתיים וחצי, תלוי בתנועה. <br/>עלות מונית: כ - 1,200 עד 2,000 באט, בהתאם לסוג הרכב והנקודה המדויקת. <br/><strong>מיניוואן ציבורי -</strong> יוצא מאזורים מרכזיים בבנגקוק (כמו Victory Monument), עלות של כ - 150 באט לאדם. <br/><strong>אוטובוס בין עירוני -</strong> יוצא מהתחנה המרכזית המזרחית של בנגקוק (Ekkamai), מגיע לתחנת האוטובוסים המרכזית בפטאיה.',
        },
        {
          subtitle: 'הפלגה מקו החוף של פטאיה לאי',
          text: 'כל המעבורות והסירות יוצאות מ - Bali Hai Pier - המזח המרכזי של פטאיה, שנמצא בקצה הדרומי של העיר ליד ה - Walking Street. ניתן לבחור בין שתי אופציות עיקריות:',
        },
        {
          subtitle: 'מעבורת ציבורית - האופציה הזולה והנוחה',
          text: 'משך הפלגה של כ - 35 עד 45 דקות, בעלות של כ - 30 באט בלבד לאדם. המעבורות פועלות, לרוב, בין 7:00 ל - 18:00 ויוצאות כל שעה או אף פחות מכך, בהתאם לעונה ולעומס. המעבורת מגיעה לרציף המרכזי של האי - Na Baan Pier. <br/><strong>יתרונות:</strong> מחיר נגיש, חוויה מקומית, הפלגה נינוחה עם נוף מרהיב על מפרץ תאילנד. <br/><strong>חסרון יחיד:</strong> מעט איטי יותר - אך בהחלט חוויה נעימה.',
        },
        {
          subtitle: 'ספיד בואט (Speed Boat) - למעוניינים בנסיעה קצרה ומהירה',
          text: 'למעוניינים בנסיעה קצרה ומהירה ו/או למעוניינים בפרטיות, משך ההפלגה הינו כ - 10 עד 15 דקות בלבד ומחיר נע בין 200  ל - 500 באט לנוסע (בהתאם לגודל הקבוצה ולמיקוח). <br/>זמינות הסירות הינה לאורך כל היום וסירות פרטיות יוצאות לפי דרישה. ניתן לבקש ירידה לא רק ברציף - Na Baan אלא גם בקרבת החופים מרכזיים (רציף Tawaen).',
        },
        {
          subtitle: 'חשוב לזכור',
          text: '✓ אם אתם מתכננים לחזור באותו היום - שימו לב לשעות המעבורת (לעיתים עד 17:00). <br/>✓ מומלץ להגיע למזח כשעה קודם לצאת המעבורת האחרונה. <br/>✓ יש לקחת בחשבון שמזג האוויר עשוי להשפיע על זמני ההפלגה, במיוחד בעונת הגשמים. <br/>✓ אם אתם מטיילים בקבוצה קטנה של 4 עד 6 אנשים - בדקו אפשרות לחלוק ספיד בואט עם מטיילים אחרים במזח ובכך להגיע במהירות ובפרטיות יחסית ותוך הוזלת עלויות.',
        },
      ],
      is12GoBanner: true,
    },
    {
      title: 'חופים מרכזיים בקו לארן',
      type: 'sub-headers',
      description:
        'למרות גודלו הקטן, קו לארן מציע מגוון חופים יפהפיים עם מים צלולים בצבע טורקיז, חול לבן ורך ואווירה טרופית מושלמת. כל חוף באי מציע חוויה שונה - ישנם חופים פעילים עם מתקנים, מסעדות ואטרקציות ויש חופים שקטים ומבודדים המתאימים למחפשים פינה שקטה ורוגע. <br/>להלן סקירה אודות החופים המרכזיים:',
      content: [
        {
          subtitle: 'Tawaen Beach - החוף הפופולרי ביותר',
          text: 'החוף הגדול והעמוס ביותר בקו לארן, ממוקם צפונית למזח Na Baan Pier. בחוף תמצאו טיילת עם חנויות, מסעדות ודוכנים, כסאות חוף להשכרה, שמשיות, ספורט ימי - בננה בוט, אופנועי ים, מצנחי רחיפה. האווירה תוססת מאוד - מתאים לחובבי פעילות ואקשן. מתאים לזוגות צעירים, חברים בקבוצות, משפחות עם ילדים גדולים.',
        },
        {
          subtitle: 'Samae Beach - נוף פתוח ואווירה נינוחה',
          text: 'חוף ארוך ופתוח במערב האי, עם נוף מרהיב לעבר האופק. החוף פחות עמוס ומפותח מחוף Tawaen, אך עדיין עם תשתיות תיירותיות. תמצאו בו מסעדות מקומיות, קפה מול הים ושקיעות מדהימות. החוף נקי ומסודר מאוד ומתאים בעיקר עבור זוגות, חובבי צילום ומשפחות עם ילדים.',
        },
        {
          subtitle: 'Monkey Beach) Nual Beach) - טבע פראי ומפגש עם קופים',
          text: 'טבע פראי ומפגש עם קופים בחוף קטן וציורי בדרום האי, שקט ומוקף בצוקים ירוקים. תמצאו בו בעיקר שקט ושלווה יחסית, אווירה  פחות ממוסחרת, אפשרות לשנורקלינג קל בקרבת הסלעים ולמפגש עם קופים המגיעים מ/ אל היער הסמוך. מתאים בעיקר לחובבי טבע, זוגות רומנטיים ולמטיילים עצמאיים.',
        },
        {
          subtitle: 'Tien Beach - גלויות חיות',
          text: 'חוף מהמם עם גוון טורקיז מבריק ומים רדודים לאורך זמן. תמצא בו סביבה רגועה במיוחד, טיילת עץ ציורית לאורך החוף, מסעדות וברים עם נוף מדהים. מתאים בעיקר למעוניינים בחוף לא עמוס, יפיפה ובאווירה טרופית שקטה.',
        },
        {
          subtitle: 'Ta Yai Beach - החוף הקטן ביותר',
          text: 'חוף אינטימי בצפון מערב האי, סמוך מאוד ל-Na Baan Pier. תמצא בו מים צלולים במיוחד, אווירה ביתית ונעימה וכל זאת במרחק הליכה מהכפר. מתאים בעיקר למעוניינים במקום נגיש ושקט למנוחה קצרה.',
        },
        {
          subtitle: 'Tong Lang Beach - פנינה נסתרת',
          text: 'חוף מבודד יחסית, אשר ניתן להגיע אליו דרך שבילים או בסירה. תמצאו בו אווירה אינטימית, נוף טבעי ולא מפותח יותר מידיי, מקום מצוין למנוחה וקריאת ספר טוב. מתאים בעיקר לתרמילאים ולזוגות המחפשים פרטיות.',
        },
        {
          subtitle: 'טיפים עבור ביקור בחופים',
          text: '✓ לחלק מהחופים ניתן להגיע אף בהליכה רגלית אך מומלץ לשכור קטנוע או להזמין מונית מקומית (טוק טוק) כדי להגיע בקלות וביעילות לכל חוף. <br/>✓ שעות הבוקר הן הזמן המומלץ ביותר לצילום ולרחצה שקטה, קודם שחופים מתמלאים. <br/>✓ חלק מהחופים מציעים כסאות בתשלום. <br/>✓ הקפידו לשמור על נקיון החופים - קו לארן שומרת על אקולוגיה מקומית והדבר חשוב מאוד.',
        },
      ],
    },
    {
      title: 'אטרקציות מרכזיות בקו לארן',
      type: 'sub-headers',
      description:
        'למרות שקו לארן הינו אי קטן יחסית, הוא מציע מגוון פעילויות מהנות המתאימות לזוגיות, משפחות, קבוצות חברים ומטיילים בודדים. חלק מהאטרקציות קשורות לטבע הימי והחופים וחלקן אף מאפשר מבט שונה על האי ואורח החיים המקומי. הנה סקירה של האטרקציות המרכזיות:',
      content: [
        {
          subtitle: 'שנורקלינג וצלילה קלה',
          text: 'קו לארן מוקפת בשוניות אלמוגים רדודות ואיים קטנים, זהו יעד מושלם לשנורקלינג, בעיקר סביב החופים Samae, Tien, ו - Nual, שם קיימים אזורים עם סלעים ושוניות המתאימות לצפייה בדגים צבעוניים. ניתן לשכור ציוד בחופים או להצטרף לטיול ימי מאורגן, המספק גם הדרכה, ציוד שנירקול.',
        },
        {
          subtitle: 'טיולי שיט סביב האי והאיים הסמוכים',
          text: 'ניתן להצטרף לשיט מאורגן או להזמין שיט פרטי ליום שלם סביב קו לארן ואיים סמוכים כמו Ko Phai, Ko Sak ועוד. הטיולים כוללים עצירות לשנורקלינג, דייג לחובבים, שחייה בלגונות סודיות ולעיתים גם ארוחת צהריים על הסיפון. זוהי גם דרך נהדרת לראות את האי מנקודת מבט ימית ולהתרחק מה מקומות העמוסים.',
        },
        {
          subtitle: 'תצפיות ונקודות צילום',
          text: 'קו לארן מציע מספר תצפיות יפות עם נוף מרהיב לים הפתוח, לחופים ולפטאיה שבאופק. הרחבה נוספת על כך, בהמשך המדריך. <br/><strong>Windmill Viewpoint-</strong> בדרך לחוף Samae, משקיפה מגובה אל עבר החוף והים. <br/><strong>Khao Nom Viewpoint-</strong> תצפית פחות מוכרת, אך מציעה שקט ונוף דרמטי של שקיעות. <br/>מומלץ מאוד להגיע לקראת השקיעה ועדיף עם מצלמה ולשבת עם קוקוס קר מול האופק.',
        },
        {
          subtitle: 'שווקונים מקומיים ודוכנים בכפר',
          text: 'לצד הנמל (Na Baan Pier) נמצא המרכז הקטן והסולידי של האי, בו תמצאו שורת חנויות ודוכנים עם מזכרות, ביגוד, אביזרי ים, נשנושים ומיצים טריים. <br/><strong>מה מיוחד?</strong> האווירה שהינה אותנטית יותר מהשווקים הגדולים בפאטאיה והאפשרות למצוא פריטים מיוחדים מעבודת יד ואשר קנייה שלהם תומכת מאוד באומנים המקומיים.',
        },
        {
          subtitle: 'ספורט ימי וחוויות חוף',
          text: 'בכמה מהחופים, בעיקר ב - Tawaen ו - Samae, תמצוא מגוון אטרקציות ימיות, כאופנועי ים, סירות בננה, סאפ, מצנחי רחיפה, סירות עם רצפת זכוכית. העלות הינה בהתאם לעונה, אך לרוב ניתנת להתמקחות קלה.',
        },
        {
          subtitle: 'סיורים סובבי אי באמצעות אופנוע',
          text: 'לשכור קטנוע ולהקיף איתו את האי, זו חוויה בפני עצמה. הדרכים מתפתלת לעיתים בין הרים קטנים, יערות טרופיים ונקודות עצירה שקטות ובכך תכירו גם פינות נסתרות, חופים צדדיים ונקודות תצפית שקטות שתיירים רבים מפספסים.',
        },
        {
          subtitle: 'חיפוש אחר פסלים ותמונות מיוחדות',
          text: 'בקו לארן יש מספר נקודות שמצטלמות היטב: שלטי ענק של "Koh Larn", נדנדות חוף עם נוף לים, פסלים צבעוניים וצמחייה טרופית המעוצבת במיוחד עבור תיירים חובבי צילום. מומלץ במיוחד עבור זוגות ומשפחות - מקומות כמו Tien Beach ו - Samae המציעים נקודות צילום המככבות ברשתות החברתיות.',
        },
        {
          subtitle: 'טיול יום מאורגן',
          text: 'מעוניינים לחוות את קו לארן באמצעות טיול יום מאורגן? נמליץ לכם על הטיולים הבאים הכוללים איסוף מהמלון בבוקר וחזרה למלון בערב, שייט הלוך - חזור מפטאיה לקו לארן, ארוחת צהריים ופעילויות שונות ב - Tawaen Beach בהתאם לתכנית המפורטת של כל טיול (מצנחי רחיפה, גלשני ים, סירות בננה, אופנועי ים, זמן חופשי לבילוי בחוף הים, שנורקלינג באי סאק)',
          link: {
            url: kohLarnGetYourGuideAttractions['pattaya-koh-larn-trip'],
            text: 'לחצו כאן ובדקו את טיול היום המאורגן לקו לארן בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
        {
          subtitle: 'טיול מבנגקוק לקו לארן',
          text: 'נמצאים בבנגקוק ותרצו לחוות את קו לארן ללא צורך בלינה בפטאיה? נמליץ לכם על הטיול הבא היוצא מבנגקוק וחוזר אליה והכולל איסוף מהמלון בבוקר וחזרה בערב, שייט הלוך - חזור לקו לארן מפטאיה, ארוחת צהריים ושלל פעילויות ימיות ב - Tawaen Beach',
          link: {
            url: kohLarnGetYourGuideAttractions[
              'bangkok-pattaya-vip-day-trip-to-koh-larn'
            ],
            text: 'לחצו כאן ובדקו את הטיול מבנגקוק לקו לארן בעצמכם',
            target: '_blank',
            rel: 'noopener noreferrer',
          },
        },
      ],
      tourIds: '1075445,1003026,973089',
    },
    {
      title: 'אתרי תרבות בקו לארן',
      type: 'sub-headers',
      description:
        'קו לארן אמנם אינו אי גדול ואין בו מבנים היסטוריים מרשימים כמו באיים גדולים יותר בתאילנד, אך דווקא הפשטות והאותנטיות של המקום הן אלו המאפשרות חוויה תרבותית ייחודית. מדובר באי עם קהילה מקומית קטנה, חמה ומסבירת פנים - בעיקר משפחות תאילנדיות מאוכלוסיית הדייגים שחיות כאן כבר דורות. מי שמבקש לחוות את התרבות המקומית באמת - ימצא מספר נקודות עניין ייחודיות:',
      content: [
        {
          subtitle: 'מקדשים מקומיים',
          text: 'באי יש כמה מקדשים בודהיסטיים קטנים הממוקמים בכפר המרכזי או בין הגבעות. המקדשים פשוטים, אך מהווים מקום תפילה ואמונה פעיל עבור המקומיים. <br/>Wat Mai Samraan הינו המקדש המרכזי של האי ומיקומו אינו רחוק מרציף המעבורות. יש בו פסל בודהה קטן, פעמונים וציורי קיר מסורתיים. מקדשים נוספים, תמצאו בעיקר על הדרך לכיוון החופים Tawaen ו - Samae, מהם אף משתקפים נופים מרהיבים. הכניסה חופשית, אך יש לנהוג בכבוד, להוריד נעליים לפני שנכנסים לאולם התפילה ולהתלבש בצניעות.',
        },
        {
          subtitle: 'התרבות הימית והדייג המסורתי',
          text: 'הדייג הינו התרבות והמסורת המקומית לאורך שנים רבות. בביקורכם באי, בעיקר באזור Na Baan Pier ובכפר הסמוך לו, תוכלו לראות את סירות הדייג עוגנות לאורך המזח, רשתות פרושות לייבוש ולעיתים אף פועלות בשעות הבוקר המוקדמות או לפנות ערב. לאלו מכם המגלים עניין - תושבים מקומיים יוכלו להסביר לכם אודות שיטות הדייג המקומיות ואף להציע לכם סיור דייג קצר (לא מסחרי, חוויה אותנטית לגמרי).',
        },
        {
          subtitle: 'חיי הכפר ואורח החיים המקומי',
          text: 'טיילו רגלית או ברכב ברחובות הצרים של הכפר ותזכו להצצה לחיי היומיום: נשים המבשלות אוכל מקומי בגז פתוח על המדרכה, ילדים הולכים לבית הספר במדים, גברים מתקנים סירות, מוכרים קוקוסים ועוד, לאורך הרחובות. זהו מקום בו לא תמצאו קניונים, אין תחבורה ציבורית מודרנית, אך יש לב פתוח, חיוך ואווירה משפחתית.',
        },
        {
          subtitle: 'חגים ופסטיבלים מקומיים',
          text: 'אם אתם מבקרים בקו לארן בזמני חגים תאילנדיים - כמו סונגקראן (אפריל) או לוי קראטונג (נובמבר), תזכו לראות את הקהילה המקומית חוגגת עם תהלוכות קטנות, מנחות למקדשים, אף טקסים יחודיים קטנים בסמוך לחוף. <br/><strong>טיפ:</strong> שאלו את בעלי המלונות/ גסטהאוסים אם מתקיימים אירועים מקומיים בזמן שהותכם באי, לעיתים אף תוזמנו להצטרף.',
        },
        {
          subtitle: 'חנויות ומזכרות של עבודות יד',
          text: 'בכמה מהחנויות והדוכנים הסמוכים לנמל או לחופים, תוכלו למצוא תכשיטים מעבודת יד, מזכרות מצדפות, תיקים ארוגים ולעיתים אף מוצרים שייצרו מקומיים מהאי עצמו - דרך מצוינת לחוות את הצד היצירתי והאומנותי של התרבות המקומית.',
        },
      ],
    },
    {
      title: 'חוויות קולינריות בקו לארן',
      type: 'sub-headers',
      description:
        'למרות גודלו הקטן של האי, קו לארן מציע חווית אוכל מיוחדת, המושפעת בעיקר מהמטבח התאילנדי הדרומי ומהקרבה לים. מדובר בשילוב נהדר בין אוכל רחוב טרי, מסעדות מקומיות פשוטות ומקומות המציעים אווירה רומנטית אל מול השקיעה. אם אתם חובבי מאכלי ים, אוכל תאילנדי חריף או פשוט מחפשים לטעום משהו חדש, קו לארן לא יאכזב אתכם.',
      content: [
        {
          subtitle: 'אוכל רחוב טרי וצבעוני',
          text: 'ברחבי האי, דגש בסמוך לרציפים ובכפרים המרכזיים, תמצאו עגלות ודוכני אוכל המוכרים כל מה שטעים: שיפודים על הגריל, בננה רוטי - הפנקייק התאילנדי האהוב, עם נוטלה, ביצה או חלב מרוכז, פאד תאי , סום טאם (סלט פאפאיה חריף), קאאו פאד (אורז מוקפץ) ועוד. המחירים נוחים מאוד ולעיתים אף תזכו לטעום מנה מדהימה במחיר של פחות מ - 50 באט.',
        },
        {
          subtitle: 'מאכלי ים טריים - מהמים לצלחת',
          text: 'קו לארן מוקף במים עשירים, מה שמבטיח אספקה יומית טרייה של מאכלים אלו ורבות מהמסעדות באי מתמחות במנות מהים. אחת החוויות המיוחדות היא לשבת על חוף הים, להזמין דג טרי לפי בחירתכם, וליהנות מארוחה פשוטה אך ורק מושלמת מול השקיעה.',
        },
        {
          subtitle: 'המטבח התאילנדי במיטבו',
          text: 'מלבד מאכלי ים, תמצאו גם מגוון מנות קלאסיות של המטבח התאילנדי - חלקן חריפות במיוחד: טום יאם גונג (מרק חריף), גרין קארי (קארי ירוק עם קוקוס) ועוד. מומלץ בכל פעם לשאול לגבי רמת החריפות - התאילנדים רגילים לחריפות גבוהה בהרבה מרוב התיירים.',
        },
        {
          subtitle: 'פירות טרופיים וקינוחים',
          text: 'אי טרופי בלי פירות, זה לא זה. תיהנו ממנגו בשל, אננס קריר, קוקוסים ירוקים לשתייה, רמבוטן, מנגוסטין וליצ\'י בעונה. בנוסף, רבים מהדוכנים מציעים שייקים מרעננים ע"ב פירות אלו - תענוג צרוף ביום חם. נסו את ה"מאנגו סטיקי רייס" - מנגו טרי עם אורז דביק ברוטב חלב קוקוס - תענוג!',
        },
        {
          subtitle: 'שתייה ומרקים מקומיים',
          text: 'תמצאו כאן תה תאילנדי קר כתום ומתוק, קפה תאילנדי חזק ואף מרקי קוקוסים, חמים, טעימים וערבים לחייך, תוך ישיבה רומנטית אל מול הים. <br/><strong>במילים אחרות-</strong> בקו לארן לא רק נחים על החוף, אלא גם מתענגים על כל ביס.',
        },
      ],
    },
    {
      title: 'מסעדות מומלצות בקו לארן',
      type: 'sub-headers',
      description:
        'למרות שטחו הקטן יחסית, קו לארן מציע מגוון מפתיע של מסעדות ודוכנים, החל ממסעדות מקומיות ופשוטות ועד למקומות טרנדיים אל מול הים. מצורף פירוט אודות מסעדות ודוכנים שזכו, לאורך זמן, להמלצות חמות ממבקרים:',
      content: [
        {
          subtitle: 'Chalianglom Kitchen',
          text: 'מסעדה מקומית ותיקה עם תפריט עשיר של דגים ומאכלי ים טריים, ממוקמת על החוף, בצידו המזרחי של האי. הדגים תמיד טריים, המחירים הוגנים, הצוות חייכן והאווירה משפחתית ונעימה - מקום מושלם לארוחת ערב אותנטית.',
        },
        {
          subtitle: 'Maharak Cafe',
          text: 'בית קפה ומסעדה קטנה ומקומית ומעוצבת באותנטיות, בקרבת הרציף. מציעה מנות תאילנדיות קלאסיות במחירים מצחיקים. נסו את הפאד תאי, הקארי הירוק והטום יאם - חריף, טעים, ומשביע. כמובן, תמצאו במקום קפה, לסוגיו הרבים ועוגות וקינוחים טעימים.',
        },
        {
          subtitle: 'Fat Submarine Café and Restaurant',
          text: "קפה חביב בלב האי, מושלם לארוחת בוקר או הפסקת קפה. המקום מציע סנדוויצ'ים, פנקייקים, קפה חזק וגם קינוחים כמו טארטים ומאפינס. יש גם מיזוג אוויר - יתרון בימי הקיץ החמים.",
        },
        {
          subtitle: 'BaanHoi',
          text: 'ממוקם בחוף Tawaen ונחשב לאחד המקומות הכי אמינים וטעימים עבור מאכלי ים באי. המנות נדיבות, כל שתבקשו תמצאו במקום ובעיקר, אווירה ביתית חמימה.',
        },
        {
          subtitle: 'Matata Bay Cafe',
          text: 'קפה שקט מול הים, בצפון מזרח האי, עם פינות ישיבה מוצלות, שקיות פוף, ומוזיקה נעימה ברקע. מקום מושלם לשבת בו בשעות אחר הצהריים, להזמין קפה קר, שייק קוקוס או חלב בננה ופשוט לנוח.',
        },
        {
          subtitle: 'דוכני אוכל מקומי ליד הרציף',
          text: 'בשעות אחה"צ המאוחרות ובערבים, סמוך לרציף, נפתח שוק אוכל קטן עם דוכנים המציעים, מרקי קוקוס, שיפודים על הגריל, בננה רוטי, מיצִים טבעיים, שייקים טריים וכל זאת, במחירים מצחיקים (20 - 40 באט).',
        },
      ],
    },
    {
      title: 'חיי לילה בקו לארן',
      type: 'sub-headers',
      description:
        'אמנם קו לארן אינו ידוע כיעד סוער בתחום חיי הלילה כמו שכנתו ממזרח - פטאיה, אך מי שהחליט ללון באי יגלה שיש בו אווירה נעימה גם בשעות הערב. לאחר שקיעת השמש, מקבל האי גוון רגוע ואינטימי - מושלם לזוגות, מטיילים יחידים וקבוצות קטנות המחפשות בילוי רגוע ליד הים.',
      content: [
        {
          subtitle: 'ברים קטנים עם אווירה ביתית',
          text: "קו לארן מציע מספר ברים קטנים הפועלים בעיקר באזור חוף Tawaen או ליד מקומות הלינה המרכזיים. אלו לא ברים רועשים אלא מקומות רגועים לשבת בהם עם קוקטייל, בירה קרה או שייק פירות ולהאזין למוזיקת רגאיי, ג'אז קליל או להיטי איייטיז.",
        },
        {
          subtitle: 'Vibe Bar Kohlarn',
          text: 'ממוקם בצידו הצפוני של חוף Tawaen ומעוצב בעיצוב "חם" במיוחד - צבע אדום עז ועץ טבעי, פסי זכוכית גדולים ופינות צילום ייחודיות - כולל נדנדת עץ מול הים ושולחנות מוצלים בגווני טבע. בשעות היום - חוויית קפה נעימה, שייקים מרעננים, קפה קר וחם, פיצות ביתיות וקינוחים, בקצב איטי ורגוע. בשעות הערב והלילה - בר באווירה שקטה, עם קוקטיילים, מבחר בירות ובידור קליל באמצעות מוזיקה חיה או פלייליסט. פופולרי מאוד בקו לארן, במיוחד בשעת השקיעה ולאחריה, פתוח עד 23:00.',
        },
        {
          subtitle: 'נקודות "מרגשות" ומיוחדות בשקיעה',
          text: 'במסעדות ובתי הקפה הסמוכים לים - כמו Sea Space, Maharak Cafe ועוד, ניתן לשבת גם אחרי רדת החשכה וליהנות מהבריזה עם כוס יין או שייק מרענן. אין מסיבות רועשות - אלא יותר אווירה של "צ\'יל על החוף".',
        },
        {
          subtitle: 'אירועים מיוחדים או מסיבות מזדמנות',
          text: 'במהלך עונות שיא (דצמבר - פברואר ובחגים תאילנדיים), ישנם אירועים פרטיים או מסיבות קטנות על החוף, במיוחד ליד מקומות הלינה הגדולים. מומלץ לשאול את צוות המלון על אירועים מעין אלו בעת שהותכם במקום - לפעמים תופתעו. <br/><strong>חשוב להכיר,</strong> כי חיי הלילה באי מסתיימים בדרך כלל סביבות 22:00 - 23:00. אם אתם מחפשים לילה סוער של מועדונים וריקודים עד השעות הקטנות, עדיף להישאר בפטאיה. קו לארן מיועד בעיקר עבור המחפשים את הצד הרגוע של תאילנד - גם בלילה.',
        },
      ],
    },
    {
      title: 'נקודות צילום מומלצות בקו לארן',
      type: 'sub-headers',
      description:
        'קו לארן הוא גן עדן לא רק לנופשים - אלא  גם לחובבי צילום. בזכות המים הצלולים, החופים הלבנים, הגבעות הירוקות ונופי השקיעה המרשימים, כמעט כל פינה מזמינה שליפה של מצלמה או טלפון. <br/>להלן המקומות שלא תרצו לפספס:',
      content: [
        {
          subtitle: 'Tawaen Beach Viewpoint',
          text: 'זו אחת מנקודות ביותר התצפית הגבוהות והיפות באי, השוכנת במרכזו - ואליה ניתן להגיע לנסיעה קצרה באופנוע או סונגטאו. מהמקום נשקף נוף עוצר נשימה של הים הפתוח, פטאיה באופק וחופים כמו Tawaen, Samae ו - Tian. תצפיות נוספות באי, עם נופים נהדרים ותמונות מיוחדות הן: Samae Beach viewpoint, The Windmill Viewpoint ועוד. <br/><strong>טיפ לצילום:</strong> הגיעו לקראת שקיעה - האור הזהוב והצללים הארוכים יוצרים קומפוזיציות מרהיבות.',
        },
        {
          subtitle: 'Tien Beach',
          text: 'החוף נחשב לאחד הפוטוגניים באי בזכות שילוב בין עצי קוקוס, סלעים דרמטיים בקצוות והים בגוון טורקיז מושלם. <br/><strong>טיפ לצילום:</strong> לכו לקצה המערבי של החוף, שם תמצאו סלעים גדולים, מהם ניתן לצלם תמונות פסטורליות עם פרספקטיבה פתוחה לים.',
        },
        {
          subtitle: 'Monkey Beach) Nual Beach)',
          text: 'חוף זה יעניק לכם שילוב בין צילומי נוף והזדמנויות לצלם קופים בטבע. הקופים מסתובבים באופן חופשי ולעיתים אף מתקרבים אל המטיילים. <br/><strong>טיפ לצילום:</strong> מומלץ להשתמש בזום ולהימנע מהתקרבות מסוכנת לקופים. צילומי קופים על רקע ים יוצרים תוצאה מצוינת.',
        },
        {
          subtitle: 'Ta Yai Beach',
          text: 'חוף קטן ואינטימי המוסתר בין עצי קוקוס. ניתן לצלם פה תמונות רומנטיות במיוחד על רקע סירות הדייגים, או לקפוץ למים ולתפוס רגעים טבעיים של שחייה, משחקים או שיזוף. <br/><strong>טיפ לצילום:</strong> בשעות הבוקר, האור בא באופן מושלם עבור צילום מים בגוון ירוק - טורקיז.',
        },
        {
          subtitle: 'סירות דייג מסורתיות',
          text: 'סירות מיוחדות של הדייגים המקומיים, עם עיטורים צבעוניים ודגלים, מהוות מוקד צילום מעניין, במיוחד בחופים המזרחיים של האי, דגש על השעות של לפנות בוקר או סמוך לשקיעה.',
        },
        {
          subtitle: 'מקדש Wat Mai Samraan',
          text: 'המקדש של האי, עם ארכיטקטורה תאילנדית, נמצא בכפר המרכזי של האי. ניתן לצלם כאן גם את הפסלים, גם את הנוף הנשקף מגבוה וגם את השילוב היפה בין מבנה רוחני וטבע המקיף אותו. <br/><strong>טיפ לצילום:</strong> מומלץ לבקר בשעות הבוקר, כשהאור רך והצללים נעימים.',
        },
        {
          subtitle: 'שבילי הליכה בגבעות האי',
          text: 'בקו לארן יש מספר שבילי הליכה על גבעות ירוקות שמהן נפתחים נופים פתוחים לים. אלו מקומות מושלמים לצילומים של הליכה בטבע, תמונות אווירה ופילטרים טבעיים של אור.',
        },
        {
          subtitle: 'צילומי דמויות ונוף אנושי',
          text: 'האי מלא בסמטאות חיים מקומיות - ילדים שמשחקים על החוף, מוכרים עם עגלות מזון, דייגים פורשים רשת. אם אתם אוהבים לתפוס רגעים אמיתיים - אלה יהיו מהתמונות היפות ביותר שתביאו הביתה.',
        },
      ],
    },
    {
      title: 'מסלול מומלץ ליום שלם בקו לארן',
      type: 'sub-headers',
      description:
        'קו לארן הינו אי קטן אך מגוון ואפשר להספיק בו המון ביום אחד, אם רק מתכננים נכון. המסלול הבא מיועד למבקרים המגיעים בבוקר במעבורת מפטאיה ומעוניינות לחוות גם את החופים, גם את הנופים וגם את האווירה המקומית.',
      content: [
        {
          subtitle: '08:00 - יציאה במעבורת מפאטאיה',
          text: 'המעבורת יוצאת מהמזח Bali Hai Pier שבפטאיה. ההפלגה אורכת כ - 40 דקות ומגיעה למזח המרכזי (Na ban Pier). טיפ: שבו בצד הימני של הסיפון לתצפית יפה על האי.',
        },
        {
          subtitle: '08:45 - השכרת אופנוע/ טוק - טוק',
          text: 'עבור טיול בשבילי האי, שכרו אופנוע קטן (עם קסדה!) או עלו על סונגטאו מקומי (רכב שירות). זוהי הדרך היעילה והמהירה ביותר לכל נקודה באי.',
        },
        {
          subtitle: '09:15 - בוקר רגוע ב - Tien Beach',
          text: 'זהו אחד החופים המרשימים והשלווים בקו לארן, עם גישה נוחה, עצי קוקוס וצל, מים רגועים וסביבה פוטוגנית במיוחד. זהו גם זמן טוב לשחייה, צילומים ולשתיית קוקוס צונן.',
        },
        {
          subtitle: '11:30 - ארוחת צהריים מוקדמת במסעדת "Sea Space"',
          text: 'מסעדה על קו החוף המציעה תפריט מגוון של דגים מאכלי ים, מנות מקומיות וקוקטיילים. האווירה נהדרת, במיוחד בעת שנושבת בריזה מהים.',
        },
        {
          subtitle: '13:00 - עלייה לתצפית המרכזית של האי',
          text: 'בנסיעה של כ - 10 דקות מגיעים לנקודת התצפית הגבוהה באי - Tawaen Beach Viewpoint. כאן תיהנו מתצפית פנורמית על כל האי, על הים הפתוח, וגם על חופי פטאיה שבאופק.',
        },
        {
          subtitle: '14:30 - Monkey Beach) Nual Beach)',
          text: 'המשיכו לחוף Nual, המזמן גם אפשרויות לראות קופים בטבע. השקט של החוף הזה מתאים מאוד למנוחה שנייה, טבילה נוספת במים או שיזוף.',
        },
        {
          subtitle: '16:00 - קפה ועוגה בבית קפה מקומי',
          text: 'קפצו לבית הקפה Fat Submarine Café או לבית קפה קטן במרכז האי. אלו מקומות שקטים ונעימים להפסקת התרעננות אחרונה לפני עזיבה.',
        },
        {
          subtitle: '17:00 - שיטוט קצר בעיירה Na Baan',
          text: 'אם נותר לכם זמן, מומלץ לטייל ברחוב הראשי של הכפר המרכזי Na Baan, בו תמצאו דוכנים, מזכרות קטנות ודגים מתובלים בסגנון מקומי ואף שוק לילה קטן הפועל בשעות אלו לא רחוק מהרציף.',
        },
        {
          subtitle: '17:30 - חזרה לפטאיה',
          text: 'המעבורת האחרונה חזרה יוצאת סביבות 17:30 - 18:00 (תלוי בעונה). הקפידו להגיע לנמל כחצי שעה קודם לעזיבת המעבורת.',
        },
        {
          subtitle: 'טיפים ליום זה',
          text: '✓ הביאו בגד ים, מגבת, קרם הגנה, בקבוק מים וכובע. <br/>✓ חלק מהחופים גובים דמי כניסה סמליים (כ - 20 באט). <br/>✓ לא לשכוח לצלם - בשעות הבוקר והשקיעה במיוחד. <br/>✓ המעבורת זולה אך איטית. ניתן להזמין אף סירה מהירה פרטית, במידה ומעוניינים בגמישות רבה יותר.',
        },
      ],
    },
    {
      title: 'חוויות למשפחות עם ילדים ולזוגות בקו לארן',
      type: 'sub-headers',
      description:
        'קו לארן, כאמור, אמנם קטן בגודלו, אך מציע שפע של פעילויות המתאימות גם למשפחות עם ילדים, בגילאים שונים וגם לזוגות המחפשים חוויה רומנטית ושקטה. האי משלב בין חופים רגועים, מים רדודים, אוכל טוב ונופים שמצטלמים נהדר - מה שהופך אותו ליעד אידיאלי לבילוי יומי או לסופ"ש קסום.',
      content: [
        {
          subtitle: 'עבור משפחות עם ילדים',
          text: '<strong>חופים רדודים ובטוחים -</strong> חוף Tien וחוף Tawaen הם מהמומלצים עבור משפחות - עם מים רדודים, שירותים נלווים ושפע של דוכנים ואפשרויות אוכל פשוטות. <br/><strong>פעילויות ימיות רכות -</strong> בחופים מרכזיים תמצאו אופציה לשכור בננות מתנפחות, קיאקים, שנורקלים ואפילו סירות זכוכית דרכן אפשר לצפות בדגים - אטרקציה שילדים אוהבים במיוחד. אוכל, דוכנים ומזכרות - השיטוט בין הדוכנים הססגוניים של הכפר Na Baan מתאים עבור משפחות, שם יוכלו למצוא ביגוד, צעצועים קטנים, מזכרות צבעוניות ואוכל מקומי לרוב. <br/><strong>נקודות צילום כיפיות -</strong> ישנן כמה נקודות עם פסלים צבעוניים ותצפיות קלות להגעה - בהם הילדים נהנים להצטלם ולרוץ חופשי. נקודת התצפית Khao Nom Sao נגישה יחסית ומתאימה גם לילדים קטנים.',
        },
        {
          subtitle: 'עבור זוגות',
          text: "<br/><strong>שקיעות מהחופים או מהתצפיות -</strong> קו לארן מתהדר בשקיעות רומנטיות במיוחד. חוף Nual נחשב לאחד המקומות היפים לראות בו את השקיעה - עם אווירה אינטימית יחסית. <br/><strong>ארוחות ערב זוגיות -</strong> בתי הקפה והמסעדות שעל קו החוף, מציעים חוויה נעימה ורומנטית במיוחד בערב, עם שולחנות על החול, אור נרות ורקע של גלים מתנפצים. <br/><strong>צילומים זוגיים -</strong> האי מצטלם נפלא, זוגות רבים מגיעים לקו לארן לצילומי זוגות וכדי להנציח את הטיול ברקע כחול - ירוק מהפנט. ניתן גם להזמין צלם מקומי. <br/><strong>שנורקלינג זוגי או שייט פרטי -</strong> ניתן לשכור סירה קטנה לסיבוב רומנטי סביב האי או להשתתף בטיול שנורקלינג מודרך לשניים - חוויה שקטה ובלתי נשכחת. <br/><strong>מסאז' זוגי -</strong> בסיום יום של טיולים, אין כמו טיפול זוגי מפנק באחד ממרכזי המסאז' הפשוטים שעל קו החוף. חלקם מציעים גם עיסויים עם שמנים, אל מול השקיעה.",
        },
      ],
    },
    {
      title: 'טיפים חשובים לקו לארן',
      type: 'sub-headers',
      description:
        'הביקור בקו לארן הינו חוויה קסומה, אך כמו בכל יעד - תכנון נכון ועצות מקצועיות יכולות לשדרג את החוויה. הנה כמה טיפים חשובים אשר כדאי לקחת בחשבון לפני ואחרי הביקור באי:',
      content: [
        {
          subtitle: 'תכננו מראש את זמני המעבורת',
          text: 'מעבורות והסירות המהירות אל/ מפטאיה, פועלות עד השעה 17:30 לערך. אם אתם מתכננים להגיע בשעות אחר הצהריים המאוחרות - ודאו שיש לכם סירה זמינה או לינה באי.',
        },
        {
          subtitle: 'הביאו כמות מספקת של מזומן',
          text: 'באזור הכפר Na Baan תמצאו חנויות קטנות, דוכני אוכל ומסעדות - אך חלקם אינם מקבלים כרטיסי אשראי. אין כספומט בכל פינה ולכן, מומלץ להצטייד בכמות מספקת של מזומן עוד מהיבשת (פטאיה).',
        },
        {
          subtitle: 'קרם הגנה ונעליים נוחות',
          text: 'השמש בקו לארן חזקה במיוחד והחופים פתוחים וחשופים רוב שעות היום. מומלץ להביא קרם הגנה איכותי, כובע, משקפי שמש ונעליים נוחות - במיוחד אם מתכננים לעלות לנקודות תצפית רגליות.',
        },
        {
          subtitle: 'נהיגה באופנוע - בזהירות !',
          text: 'השכרת אופנועים נפוצה מאוד, אך הכבישים באי צרים, מפותלים ולעיתים, עשויות להיות עליות תלולות. אם אין לכם ניסיון ברכיבת אופנוע, שקלו את הנסיעה בסונגטאו המקומי או פשוט, התניידו רגלית בין האזורים המרכזיים.',
        },
        {
          subtitle: 'שמרו על ניקיון האי',
          text: 'קו לארן מתמודד עם בעיית פסולת, במיוחד בעונת השיא. אנא הביאו עימכם שקית אשפה קטנה, וודאו שכל פסולת נאספת ונזרקת במקומות המיועדים לכך. תיירות אחראית, עוזרת לשמור על יופיו של האי.',
        },
        {
          subtitle: 'קליטה סלולרית ואינטרנט',
          text: 'הקליטה הסלולרית ברוב חלקי האי טובה, אך באזורים פחות מתויירים ייתכנו ניתוקים קלים. אם אתם זקוקים לחיבור רציף - שקלו לרכוש חבילת גלישה מקומית מחברות כמו AIS או TrueMove.',
        },
        {
          subtitle: 'שווה לישון באי - אך לא חובה',
          text: 'רבים מגיעים לקו לארן לטיול יומי בלבד, אך במידה והינכם מעוניינים בחוויה שלווה, שקיעות קסומות ובוקר על חוף מבודד - שווה להישאר לילה אחד לפחות. זהו גם פתרון נוח למעוניינים להתרחק מלחץ ההמונים החוזרים לפטאיה בשעות אחה"צ.',
        },
        {
          subtitle: 'היו מוכנים לצילום - האי פשוט פוטוגני',
          text: 'בין אם אתם חובבי אינסטגרם ובין אם אתם מצלמים רק למזכרת, מומלץ להביא מצלמה או טלפון טעון - מאחר וכל פינה בקו לארן שווה תיעוד. השקיעות, התצפיות, החופים והטבע - יוצרים תמונות בלתי נשכחות.',
        },
        {
          subtitle: 'הביאו מים ואוכל קל מהיבשת',
          text: 'למרות שלא חסרים דוכנים באי, מומלץ להביא בקבוק מים אישי וחטיפים לדרך - במיוחד אם אתם נוסעים עם ילדים או עולים לנקודות תצפית מרוחקות.',
        },
        {
          subtitle: 'טיפ אחרון וחשוב',
          text: 'קו לארן אולי נראה כמו "אי קטן ליד פטאיה", אבל הוא יכול להפוך לזיכרון גדול בטיול שלכם - אם רק תתנו לו את הזמן והלב.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content:
        'קו לארן הינו יעד נפלא למחפשים חופי גן עדן במרחק נגיעה מפטאיה. האי משלב בין חופים קסומים, פעילויות מים מרגשות ואווירה רגועה המתאימה לכל סוגי המטיילים. בין אם תבחרו לטייל אליו ליום אחד ובין אם ללון בו ללילה, קו לארן הוא, ללא ספק, מקום שלא כדאי לפספס בטיול שלכם בתאילנד!',
      type: 'text',
      isBold: true,
    },
  ],
};
